class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ============================================================================
   RECONCILIACION DEL REGALO (2026-08-16) — nuestro, no es de Dawn.
   ============================================================================
   QUE ARREGLA
   El regalo NO es una linea que el cliente maneja: es una FUNCION de las lineas que si paga.
   Despues del add nada las volvia a atar, asi que si el cliente borraba un arnes (o los dos), la
   correa gratis quedaba huerfana — y con el candado de regalos del 09/08 encima (sin stepper ni
   tacho, ver is_gift_line en snippets/cart-drawer.liquid) NO habia forma de sacarla. Se
   despacharon 2 correas de mas en las ordenes #1268 y #1269, que son las dos ultimas ventas.
   Ver learnings/regalo-huerfano-en-el-carrito-2026-08-16.md.

   DE DONDE SACA EL ESTADO
   De snippets/gift-recon.liquid, que renderiza sections/cart-drawer.liquid. Se pide con
   ?sections=cart-drawer, o sea que SIEMPRE viene recalculado por el server: no hay copia en el DOM
   que pueda quedar vieja. Es generico: no hay una linea que diga "correa" ni "arnes", todo sale
   del metafield pdp_free_gift con la misma resolucion por handle + color_map que la PDP.

   POR QUE VIVE ACA Y NO EN UN ASSET NUEVO
   Porque un asset nuevo necesita un <script src> en alguna parte, y las unicas paginas-madre que
   lo renderizarian son layout/theme.liquid (22 KB) o snippets/cart-drawer.liquid (54 KB): tocar
   cualquiera de las dos es mucho mas riesgo que agregar codigo al final del JS del propio drawer,
   que ya se carga en todas las paginas.

   TRES CANDADOS, porque esto BORRA cosas del carrito de alguien que esta comprando:
     1. Nunca deja el total de regalos por DEBAJO del esperado. Se calcula cuantas unidades sobran
        EN TOTAL y se recorta como mucho esa cantidad. Si el color_map algun dia resolviera
        distinto de lo que la PDP agrego, el sobrante da 0 y esto no toca nada: el cliente se queda
        con su regalo. Preferimos regalar de mas antes que romper la promesa de la pagina.
     2. Nunca agrega. El caso inverso (2 arneses, 1 correa) ya lo cubre per_unit en la PDP.
     3. No se actua dos veces sobre el MISMO estado (ultimaFirma) y hay un tope de vueltas por
        pageview. Sin eso, un change que no se aplica deja el estado igual y el ciclo
        correr -> change -> correr se repite contra el server sin fin.
        OJO: el guard NO puede ser "esta line key ya se toco", que fue el primer intento y esta mal:
        la key es variante+propiedades, o sea que el mismo regalo huerfano en un carrito nuevo trae
        la MISMA key y quedaba blindado para el resto del pageview. Falla encontrada en el QA.

   Si el fetch falla o el JSON no parsea, no hace nada: el peor caso es el comportamiento de antes,
   nunca un carrito roto. Y NO usa renderContents() a proposito: ese metodo ABRE el cajon, y esto
   corre solo en el load de cualquier pagina — abrirle el carrito a alguien que no lo pidio parece
   un bug. Repinta el mismo HTML a mano, sin abrir nada.
   ============================================================================ */
(function () {
  if (window.__giftReconBound) return;
  window.__giftReconBound = true;

  var ocupado = false;
  var ultimaFirma = null;
  var vueltas = 0;
  var TOPE_VUELTAS = 20;

  function estado(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('#gift-recon-data');
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      return null;
    }
  }

  /* Devuelve [{key, to}]: a que cantidad hay que llevar cada linea de regalo. */
  function recortes(data) {
    if (!data) return [];
    var quiere = {};
    var esperado = 0;
    var actual = 0;
    (data.hosts || []).forEach(function (h) {
      quiere[h.variant] = (quiere[h.variant] || 0) + h.qty;
      esperado += h.qty;
    });
    (data.gifts || []).forEach(function (g) {
      actual += g.qty;
    });
    var sobran = actual - esperado;
    if (sobran <= 0) return [];
    /* Primero las lineas que no le corresponden a NINGUN producto del carrito (sobrante puro),
       despues el excedente de las que si corresponden. */
    var cand = (data.gifts || [])
      .map(function (g) {
        return { key: g.key, qty: g.qty, quiere: quiere[g.variant] || 0 };
      })
      .filter(function (g) {
        return g.qty > g.quiere;
      })
      .sort(function (a, b) {
        return a.quiere - b.quiere;
      });
    var out = [];
    cand.forEach(function (g) {
      if (sobran <= 0) return;
      var saca = Math.min(g.qty - g.quiere, sobran);
      sobran -= saca;
      out.push({ key: g.key, to: g.qty - saca });
    });
    return out;
  }

  function trozo(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  /* Repinta lo que ya esta en pantalla, SIN abrir el cajon (ver el comentario de arriba). */
  function pintar(res) {
    if (!res || !res.sections) return;
    try {
      var cd = document.getElementById('CartDrawer');
      if (cd && res.sections['cart-drawer']) {
        var inner = trozo(res.sections['cart-drawer'], '#CartDrawer');
        if (inner !== null) cd.innerHTML = inner;
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && res.sections['cart-icon-bubble']) {
        var b = trozo(res.sections['cart-icon-bubble'], '.shopify-section');
        if (b !== null) bubble.innerHTML = b;
      }
      if (res.item_count === 0) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.add('is-empty');
        var di = document.querySelector('cart-drawer .drawer__inner');
        if (di) di.classList.add('is-empty');
      }
    } catch (e) {
      console.error('[gift-recon]', e);
    }
  }

  function aplicar(lista, i, ultimo) {
    if (i >= lista.length) {
      terminar(ultimo);
      return;
    }
    var e = lista[i];
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: e.key,
        quantity: e.to,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (res) {
        aplicar(lista, i + 1, res || ultimo);
      })
      .catch(function () {
        ocupado = false;
      });
  }

  function terminar(res) {
    ocupado = false;
    pintar(res);
    /* En /cart la lista la dibuja main-cart-items, que no se entera de este fetch. Se recarga UNA
       sola vez por sesion: si por lo que fuera el recorte no quedara aplicado, un reload en loop es
       mucho peor que una fila desactualizada. */
    if (/^\/cart(\/|$)/.test(window.location.pathname)) {
      try {
        if (!sessionStorage.getItem('giftReconReloaded')) {
          sessionStorage.setItem('giftReconReloaded', '1');
          window.location.reload();
        }
      } catch (e) {}
    }
  }

  function correr() {
    if (ocupado) return;
    var drawer = document.querySelector('cart-drawer');
    /* Carrito vacio: no hay nada que reconciliar y nos ahorramos el request. */
    if (drawer && drawer.classList.contains('is-empty')) return;
    if (vueltas >= TOPE_VUELTAS) return;
    ocupado = true;
    /* SIN el header Accept: application/json. Con ese header Shopify devuelve la seccion VACIA
       (medido el 16/08 en el QA: 0 caracteres contra 59.716 sin el header), y el reconciliador se
       quedaba callado creyendo que no habia nada que hacer. La respuesta ya viene en JSON igual. */
    fetch(window.location.pathname + '?sections=cart-drawer', { cache: 'no-store' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (s) {
        if (!s || !s['cart-drawer']) {
          ocupado = false;
          return;
        }
        var data = estado(s['cart-drawer']);
        var firma = data ? JSON.stringify(data) : null;
        /* Mismo estado que la ultima vez que actuamos = nuestro change no se aplico. Cortar aca es
           lo que evita el loop infinito contra el server. */
        if (!firma || firma === ultimaFirma) {
          ocupado = false;
          return;
        }
        var lista = recortes(data);
        if (!lista.length) {
          ocupado = false;
          return;
        }
        ultimaFirma = firma;
        vueltas += 1;
        aplicar(lista, 0, null);
      })
      .catch(function () {
        ocupado = false;
      });
  }

  /* Al cargar repara ademas los carritos que ya venian sucios de antes de este fix. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correr);
  } else {
    correr();
  }
  /* cart:refresh lo tiran pdp-factory.js y el cross-sell del drawer; cartUpdate es el pub/sub de
     Dawn (cambios de cantidad y borrados desde el carrito). El delay deja que termine el render
     que disparo el evento. */
  document.addEventListener('cart:refresh', function () {
    setTimeout(correr, 500);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(correr, 500);
    });
  }
})();
